import { LocalDate } from '../../store';
import { PlannedDates } from '../../common';

export interface TransportationTrackingParty {
  type: string;
  id: string;
  name: string;
  address: string;
}

export interface TransportationTrackingPlannedDates extends PlannedDates {
  // for load
  plannedArrival?: LocalDate;
  plannedDeparture?: LocalDate;
}

export interface TransportationTrackingDates extends TransportationTrackingPlannedDates {
  actualArrival: LocalDate;
  actualDeparture: LocalDate;
  estimatedArrival: LocalDate;
  estimatedDeparture: LocalDate;
}

export interface TransportationTrackingHistoryDate extends TransportationTrackingPlannedDates {
  receivedTimestamp: LocalDate;
}

export enum TransportationTrackingDateType {
  Planned = 'PLANNED',
  Estimated = 'ESTIMATED',
  Actual = 'ACTUAL',
  LoadPlanned = 'LOAD_PLANNED',
}

export interface TransportationTrackingDateItem {
  type: TransportationTrackingDateType;
  values: LocalDate[];
}

export const TRANSPORTATION_TRACKING_DATES_ORDERING: TransportationTrackingDateType[] = [
  TransportationTrackingDateType.LoadPlanned,
  TransportationTrackingDateType.Planned,
  TransportationTrackingDateType.Estimated,
  TransportationTrackingDateType.Actual,
];

export const TRANSPORTATION_TRACKING_DATES_REVERSE_ORDERING: TransportationTrackingDateType[] = [
  ...TRANSPORTATION_TRACKING_DATES_ORDERING,
].reverse();

export enum TransportationTrackingDateField {
  PlannedArrivalEnd = 'plannedArrivalEnd',
  PlannedArrivalStart = 'plannedArrivalStart',
  PlannedDepartureEnd = 'plannedDepartureEnd',
  PlannedDepartureStart = 'plannedDepartureStart',
  EstimatedArrival = 'estimatedArrival',
  EstimatedDeparture = 'estimatedDeparture',
  ActualArrival = 'actualArrival',
  ActualDeparture = 'actualDeparture',
  PlannedArrival = 'plannedArrival',
  PlannedDeparture = 'plannedDeparture',
}

export enum TransportationTrackingActionType {
  Pickup = 'PICKUP',
  Delivery = 'DELIVERY',
  PickupStarted = 'PICKUP_STARTED',
  DeliveryStarted = 'DELIVERY_STARTED',
  PortOfLoading = 'PORT_OF_LOADING',
  PortOfDischarge = 'PORT_OF_DISCHARGE',
  WarehouseStop = 'WAREHOUSE_STOP',
}

export enum MapTrackingActionTypeNames {
  Discharge = 'DISCHARGE',
  Loading = 'LOADING',
  Transshipment = 'TRANSSHIPMENT',
}

export interface TransportationTrackingAllTypesDatesModel {
  [TransportationTrackingDateType.Planned]: TransportationTrackingDateField[];
  [TransportationTrackingDateType.Estimated]: TransportationTrackingDateField[];
  [TransportationTrackingDateType.Actual]: TransportationTrackingDateField[];
  [TransportationTrackingDateType.LoadPlanned]: TransportationTrackingDateField[];
}

export class TransportationTrackingDatesConfigModel {
  [TransportationTrackingActionType.Pickup]: TransportationTrackingAllTypesDatesModel;
  [TransportationTrackingActionType.Delivery]: TransportationTrackingAllTypesDatesModel;
}

export const TRANSPORTATION_TRACKING_DATES_CONFIG: TransportationTrackingDatesConfigModel = {
  [TransportationTrackingActionType.Pickup]: {
    [TransportationTrackingDateType.Planned]: [
      TransportationTrackingDateField.PlannedDepartureStart,
      TransportationTrackingDateField.PlannedDepartureEnd,
    ],
    [TransportationTrackingDateType.LoadPlanned]: [TransportationTrackingDateField.PlannedDeparture],
    [TransportationTrackingDateType.Estimated]: [TransportationTrackingDateField.EstimatedDeparture],
    [TransportationTrackingDateType.Actual]: [TransportationTrackingDateField.ActualDeparture],
  },
  [TransportationTrackingActionType.Delivery]: {
    [TransportationTrackingDateType.Planned]: [
      TransportationTrackingDateField.PlannedArrivalStart,
      TransportationTrackingDateField.PlannedArrivalEnd,
    ],
    [TransportationTrackingDateType.LoadPlanned]: [TransportationTrackingDateField.PlannedArrival],
    [TransportationTrackingDateType.Estimated]: [TransportationTrackingDateField.EstimatedArrival],
    [TransportationTrackingDateType.Actual]: [TransportationTrackingDateField.ActualArrival],
  },
};
